import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface ParentsBulkImportJobListItem {
  jobId: string;
  status: string;
  completedAt: string | null;
  createdAt: string;
  totalRecords: number;
  studentsCreated: number;
  warningsCount: number;
  needsAttentionCount: number;
  actionItemCount: number;
  batchId: string | null;
  correlationId: string | null;
}

export interface ParentsBulkImportJobsResponse {
  success: boolean;
  jobs: ParentsBulkImportJobListItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface GetParentsBulkImportJobsParams {
  page?: number;
  limit?: number;
  needsAction?: boolean;
}

export const getParentsBulkImportJobsAPI = async (
  params: GetParentsBulkImportJobsParams = {},
) => {
  const response = await baseAPI.get<ParentsBulkImportJobsResponse>(
    '/parents/bulk-import-jobs',
    {
      params: {
        page: params.page ?? 1,
        limit: params.limit ?? 20,
        ...(params.needsAction ? { needsAction: 'true' } : {}),
      },
    },
  );
  return response.data;
};

export const getParentsBulkImportJobsQueryOptions = (
  params: GetParentsBulkImportJobsParams = {},
) =>
  queryOptions({
    queryKey: [KEYS.PARENTS_BULK_IMPORT_JOBS, params],
    queryFn: () => getParentsBulkImportJobsAPI(params),
  });

export const useGetParentsBulkImportJobs = (
  params: GetParentsBulkImportJobsParams = {},
) => useQuery(getParentsBulkImportJobsQueryOptions(params));
